<template>
  <div class="swiper-wrap">
    <div class="swiper news-swiper" data-swiper-id="swiperNews">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, idx) in banner" :key="idx">
          <div class="news-banner-item">
            <a href="javascript:void(0);" class="anchor" @click="openPop(item)">
              <div class="thumb">
                <div class="thumb-img">
                  <img :src="item.bnnrImageUrl" alt="" />
                </div>
              </div>
              <div class="thumb-bottom">
                <p class="text" v-html="sanitizeHTML(item.bnnrTitleNm)"></p>
                <i class="c-icon icon-plus"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="c-swiper-indicator" data-swiper-indicator-id="swiperNews"></div>
  </div>
</template>

<script setup name="Prod04Swiper">
import { onMounted, reactive, inject, nextTick, ref } from "vue";
import { api } from "@/plugins/api";
import * as cmUtil from "@/utils/cmUtil.js";

//Swiper
import Swiper, { Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const url = inject("url_prefix");
const banner = ref([]);

const data = reactive({
  swiper: {
    loading: false,
    type: {},
    tabType: "",
    search: {},
    data: [],
  },
});

/**********************
 * 스와이퍼 호출
 *********************/
function initSwiper() {
  new Swiper("[data-swiper-id='swiperNews']", {
    modules: [Pagination, Autoplay],
    speed: 400,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: banner.value.length > 1 ? 2000 : 99999000,
    },
    pagination: {
      el: '[data-swiper-indicator-id="swiperNews"]',
      type: "bullets",
      clickable: true,
    },
  });
}

/**********************
 * 조회 모음
 *********************/
async function mainSwiper04() {
  //data.swiper.loading = true;
  const res = await api.post(`${url}/main/mainNew01`, {});

  data.swiper.data = res.data;

  banner.value = res.data.map((item) => {
    return {
      ...item,
      bnnrImageUrl: FILE_CDN_URL + item.filePath + "/" + item.physFileNm,
    };
  });
  await nextTick();
  initSwiper();
}

// 뉴스배너 새창으로 열기
async function openPop(data) {
  window.open(data.bnnrLinkUrl, "_blank");
}

/**********************
 * 마운트
 *********************/
onMounted(() => {
  mainSwiper04();
});

// script 태그와 이벤트 핸들러 제거
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}
</script>
